import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Descriptions, Icon } from 'antd';
import Confirm from '../Confirm';

const modalStyles = `
@keyframes cd-bar { 0%{background-position:0% center} 100%{background-position:200% center} }
@keyframes cd-float { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-3px)} }
@keyframes cd-glow { 0%,100%{box-shadow:0 0 0 0 rgba(24,144,255,0.4)} 50%{box-shadow:0 0 0 10px rgba(0,0,0,0)} }
@keyframes modal-pop { from{opacity:0;transform:scale(0.96) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }

.cd-modal .ant-modal-content { border-radius:14px!important; overflow:hidden!important; box-shadow:0 24px 64px rgba(0,0,0,.16),0 0 0 1px rgba(24,144,255,.1)!important; animation:modal-pop .3s cubic-bezier(.22,1,.36,1) both!important; }
.cd-modal .ant-modal-header { padding:0!important; border-bottom:none!important; }
.cd-modal .ant-modal-body   { padding:0!important; }
.cd-modal .ant-modal-footer { border-top:1px solid #f0f5ff!important; padding:12px 20px!important; display:flex; justify-content:flex-end; gap:8px; }
.cd-modal .ant-modal-close  { top:14px!important; right:16px!important; color:rgba(255,255,255,0.8)!important; transition:color .2s,transform .2s!important; }
.cd-modal .ant-modal-close:hover { color:#fff!important; transform:rotate(90deg)!important; }
.cd-modal .ant-modal-close .ant-modal-close-x { width:36px!important; height:36px!important; line-height:36px!important; }

.cd-header { background:linear-gradient(135deg,#003a8c 0%,#0050b3 35%,#1890ff 70%,#096dd9 100%); padding:18px 22px 16px; display:flex; align-items:center; gap:14px; position:relative; overflow:hidden; }
.cd-header::before { content:''; position:absolute; inset:0; background-image:radial-gradient(rgba(255,255,255,.09) 1px,transparent 1px); background-size:20px 20px; pointer-events:none; }
.cd-header::after  { content:''; position:absolute; bottom:0; left:0; right:0; height:3px; background:linear-gradient(90deg,#13c2c2,#1890ff,#52c41a,#fa8c16,#13c2c2); background-size:300% auto; animation:cd-bar 3s linear infinite; }
.cd-header-icon { width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; animation:cd-glow 2.6s ease-in-out infinite,cd-float 3s ease-in-out infinite; }
.cd-header-title { font-size:15px; font-weight:800; color:#fff; letter-spacing:.8px; }
.cd-header-sub   { font-size:11px; color:rgba(255,255,255,.6); letter-spacing:1px; margin-top:2px; }

.cd-body { padding:20px 22px; }
.cd-modal .ant-descriptions-title { font-size:11px!important; font-weight:700!important; color:#1890ff!important; letter-spacing:1px!important; text-transform:uppercase!important; }
.cd-modal .ant-descriptions-item-label { background:#f0f7ff!important; font-size:11px!important; font-weight:700!important; color:#595959!important; }
.cd-modal .ant-descriptions-item-content { font-size:13px!important; color:#262626!important; font-weight:500!important; }
.cd-modal .ant-descriptions-bordered .ant-descriptions-item-label,
.cd-modal .ant-descriptions-bordered .ant-descriptions-item-content { border-color:#e6f0ff!important; }

.cd-btn-reject { border-radius:8px!important; height:34px!important; font-size:12px!important; font-weight:700!important; border:1.5px solid #ffa39e!important; background:#fff1f0!important; color:#ff4d4f!important; transition:all .2s!important; }
.cd-btn-reject:hover { background:#ff4d4f!important; color:#fff!important; border-color:#ff4d4f!important; box-shadow:0 4px 12px rgba(255,77,79,.35)!important; }
.cd-btn-approve { border-radius:8px!important; height:34px!important; font-size:12px!important; font-weight:700!important; background:linear-gradient(135deg,#52c41a 0%,#389e0d 100%)!important; border:none!important; box-shadow:0 4px 14px rgba(82,196,26,.35)!important; transition:all .2s!important; }
.cd-btn-approve:hover { transform:translateY(-1px)!important; box-shadow:0 6px 20px rgba(82,196,26,.45)!important; }
`;

const CustomerDetails = props => {
  const { data, closeModal, visible, updateCustomer, setLoading } = props;
  const isRecommended = data.isApproved === 'RECOMMENDED';

  const footer = isRecommended ? (
    <>
      <Button className="cd-btn-reject" icon="close-circle"
        onClick={() => Confirm(updateCustomer, null, { id: data.id, method: 'rejected', src: 'gm' }, setLoading, closeModal)}>
        Reject
      </Button>
      <Button className="cd-btn-approve" icon="check-circle" type="primary"
        onClick={() => Confirm(updateCustomer, null, { id: data.id, method: 'approved', src: 'gm' }, setLoading, closeModal)}>
        Approve
      </Button>
    </>
  ) : null;

  return (
    <>
      <style>{modalStyles}</style>
      <Modal className="cd-modal" visible={visible} footer={footer} style={{ top: 25 }} width={680} onCancel={closeModal}
        title={
          <div className="cd-header">
            <div className="cd-header-icon">
              <Icon type="contacts" style={{ fontSize: 20, color: '#fff' }} />
            </div>
            <div>
              <div className="cd-header-title">{data.bi_name || 'CUSTOMER DETAILS'}</div>
              <div className="cd-header-sub">Business Information</div>
            </div>
            {isRecommended && (
              <div style={{ marginLeft: 'auto' }}>
                <span style={{ display:'inline-flex',alignItems:'center',gap:5,background:'rgba(250,140,22,.2)',border:'1px solid rgba(250,140,22,.4)',borderRadius:20,padding:'3px 10px',fontSize:11,fontWeight:700,color:'#fa8c16',letterSpacing:'.5px' }}>
                  <span style={{ width:6,height:6,borderRadius:'50%',background:'#fa8c16',boxShadow:'0 0 6px #fa8c16' }} />
                  FOR APPROVAL
                </span>
              </div>
            )}
          </div>
        }
      >
        <div className="cd-body">
          <Descriptions column={2} size="small" title="BUSINESS INFORMATION" bordered>
            <Descriptions.Item span={2} label="Business Name">{data.bi_name}</Descriptions.Item>
            <Descriptions.Item span={2} label="Business Address">{data.bi_address}</Descriptions.Item>
            <Descriptions.Item span={2} label="Nature of Business">{data.bi_nature}</Descriptions.Item>
            <Descriptions.Item span={1} label="Tel No.">{data.bi_tel}</Descriptions.Item>
            <Descriptions.Item span={1} label="Fax No.">{data.bi_fax}</Descriptions.Item>
            <Descriptions.Item span={1} label="SSS No.">{data.bi_sss}</Descriptions.Item>
            <Descriptions.Item span={1} label="TIN No.">{data.bi_tin}</Descriptions.Item>
            <Descriptions.Item span={2} label="Email Address">{data.bi_email}</Descriptions.Item>
            <Descriptions.Item span={1} label="Years in Business">{data.bi_yearsBusiness}</Descriptions.Item>
            <Descriptions.Item span={1} label="Business Premises">{data.bi_premises}</Descriptions.Item>
            <Descriptions.Item span={2} label="Business Type">{data.bi_type}</Descriptions.Item>
            <Descriptions.Item span={1} label="Contact Person">{data.bi_contact}</Descriptions.Item>
            <Descriptions.Item span={1} label="Position">{data.bi_contactposition}</Descriptions.Item>
          </Descriptions>
        </div>
      </Modal>
    </>
  );
};

CustomerDetails.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  visible: PropTypes.bool.isRequired,
  updateCustomer: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};
export default CustomerDetails;